const showToast = (message, type = "success") => {
  if (typeof window === "undefined") return;

  const toast = document.createElement("div");
  toast.className = `ao-toast ao-toast--${type}`;
  toast.setAttribute("role", "status");
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add("is-leaving");
    setTimeout(() => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 300);
  }, type === "error" ? 3000 : 4000);
};

export const toastifySuccess = (message) => showToast(message, "success");
export const toastifyError = (message) => showToast(message, "error");
